import { PrimaryButton } from '@grays-npm/component-library';
import { useModal } from '../../state/modal';
import { useNavigate } from 'react-router-dom';
import { StyledBody, StyledHeading } from '../Modal/ModalStyles';
import { useCMSData } from '../../state/content-manager';

export const DashboardPromoteItem: React.FC = () => {
  const cmsData = useCMSData();
  const { subBody, title } = cmsData.modals.dashboardPromote;

  const { setModalProps } = useModal();
  let navigate = useNavigate();

  const goToListings = () => {
    navigate('/listings');
    setModalProps({
      isOpen: false,
    });
  };
  return (
    <div>
      <StyledHeading>{title}</StyledHeading>
      <StyledBody>
        {subBody && <span dangerouslySetInnerHTML={{ __html: subBody }}></span>}
      </StyledBody>

      <PrimaryButton size="large" onClick={goToListings}>
        Your Listings
      </PrimaryButton>
    </div>
  );
};
